<template>
  <div>
    <el-card>
      <el-table
        border
        :height="tableHeight"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        :data="tableData"
        ref="multipleTable"
        tooltip-effect="dark"
        v-loading="config.loading"
        v-el-table-infinite-scroll="load"
        infinite-scroll-disabled="onLoading"
      >
        <el-table-column width="50">    
            <template slot-scope="scope">
            <el-radio
              style="margin-left: 10px"
              :label="scope.$index"
              v-model="radio"
              @change.native="handleSelectionChange(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <template v-for="(item, index) in configTable">
          <el-table-column
            :prop="item.prop"
            :label="item.label"
            :key="index"
            :width="item.cinfigWidth"
          ></el-table-column>
        </template>
      </el-table>
      <el-alert
        v-if="onMore"
        title="没有更多数据了!"
        type="warning"
        center
        :closable="false"
      >
      </el-alert>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "GiadaTable",
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    configTable: {
      type: Array,
      default: () => {
        return [];
      },
    },
    config:Object,
    tableHeight:String
  },
  data() {
    return {
      radio:"",
      isMore:false
    };
  },
   computed: {
    onMore() {
      return this.config.pageNo >= this.config.total/this.config.pages;
    },
    onLoading() {
      return this.config.loading || this.onMore;
    },
  },
  methods: {
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    handleSelectionChange(value) {
      this.$emit("selectChange", value);
    }, 
    load() {
      this.$emit("load");
    },
    // ding(){
    //   this.$emit('loading', false);
    // }

  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  // table隔行变色
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5;
    color: #ffffff;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5;
  }
}
</style>